var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resource-card"},[_c('div',[_c('img',{staticClass:"img-fluid mb-2",staticStyle:{"width":"76px"},attrs:{"src":_vm.logo,"alt":"Logo Not Found"}}),_c('h5',[_vm._v(_vm._s(_vm.name))])]),_c('p',[_vm._v(_vm._s(_vm.description))]),_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v("Visit Website")])])
}
var staticRenderFns = []

export { render, staticRenderFns }